/**
 * @generated SignedSource<<4639d301ed08206610894c16a4bfa067>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAnswerInput = {
  answerId?: string | null | undefined;
  answerRawId?: number | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type AnswerListItem_DeleteAnswerMutation$variables = {
  input: DeleteAnswerInput;
};
export type AnswerListItem_DeleteAnswerMutation$data = {
  readonly deleteAnswer: {
    readonly answer: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type AnswerListItem_DeleteAnswerMutation = {
  response: AnswerListItem_DeleteAnswerMutation$data;
  variables: AnswerListItem_DeleteAnswerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnswerListItem_DeleteAnswerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAnswerPayload",
        "kind": "LinkedField",
        "name": "deleteAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Answer",
            "kind": "LinkedField",
            "name": "answer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnswerListItem_DeleteAnswerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAnswerPayload",
        "kind": "LinkedField",
        "name": "deleteAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Answer",
            "kind": "LinkedField",
            "name": "answer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86b2eab1faa92b63302bfc9f54dd82d3",
    "id": null,
    "metadata": {},
    "name": "AnswerListItem_DeleteAnswerMutation",
    "operationKind": "mutation",
    "text": "mutation AnswerListItem_DeleteAnswerMutation(\n  $input: DeleteAnswerInput!\n) {\n  deleteAnswer(input: $input) {\n    answer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "480eb1af2c4303e7275d954bb62eaef7";

export default node;
